(()=>{const root=window.document.getElementById('stikkma-hats-v1');if(!root)return;
const resolve=window.StikkmaHatAssets.resolve,Image=window.StikkmaHatAssets.Image,fetch=window.StikkmaHatAssets.fetch;
const document=new Proxy(window.document,{get(t,p){if(p==='querySelector')return s=>root.querySelector(s);if(p==='querySelectorAll')return s=>root.querySelectorAll(s);if(p==='getElementById')return id=>root.querySelector('#'+CSS.escape(id));const v=Reflect.get(t,p,t);return typeof v==='function'?v.bind(t):v;}});
/* Shared per-piece prices for the product previews and browser-local basket. */
window.StikkmaPricing=(()=>{
  const textPrice=5,motifPrice=7.5;
  const hasText=config=>!!config?.personal&&typeof config.name==='string'&&config.name.trim().length>0;
  const hasMotif=config=>!!config?.personal&&(window.StikkmaHatMotifs?.has(config)??['heart','mountain','paw','legacy:heart','legacy:mountain','legacy:paw'].includes(config.motifId||config.motif));
  const hasEmbroidery=config=>hasText(config)||hasMotif(config);
  const money=n=>n.toLocaleString('de-DE',{style:'currency',currency:'EUR'});
  const describe=q=>[q.textEmbroidery?'Textstick '+money(q.textEmbroidery):'',q.motifEmbroidery?'Motivstick '+money(q.motifEmbroidery):''].filter(Boolean).join(' · ');
  const giftChoices=()=>window.CuscoCatalog.poms.flatMap((p,i)=>['style-KF129','style-KF16-3'].includes(p.id)?[i]:[]);
  const countPoms=c=>(c.quantities||[]).reduce((n,q)=>n+Math.max(0,Math.floor(Number(q)||0)),0);
  function giftIndex(c){const i=c.giftPom;return Number.isInteger(i)&&giftChoices().includes(i)&&Number(c.quantities?.[i])>0&&countPoms(c)>=4?i:-1;}
  function normalizeGift(c){
    const i=c.giftPom;
    if(giftIndex(c)>=0)return;
    // When a paid pom is removed, its no-longer-qualified gift leaves the mix too.
    if(Number.isInteger(i)&&giftChoices().includes(i)&&c.quantities?.[i]>0)c.quantities[i]--;
    c.giftPom=-1;
  }
  function chooseGift(c,i){
    normalizeGift(c);const current=giftIndex(c),paid=countPoms(c)-(current>=0?1:0);
    if(!giftChoices().includes(i)||paid<3||window.StikkmaPomStock?.active(i)===false)return false;
    if(current===i)return true;
    if(c.quantities[i]>=window.StikkmaPomStock.limit(i))return false;
    if(current>=0)c.quantities[current]--;
    c.quantities[i]++;c.giftPom=i;return true;
  }
  function quote(modelId,config={}){
    const model=window.HatCollection.models.find(m=>m.id===modelId);
    const color=model?.colors.find(c=>c.label===config.color);
    const base=modelId==='bommel'?0:color?.price;
    const prices=(modelId==='bommel'||model?.pomType==='removable')?
      window.CuscoCatalog.poms.flatMap((pom,i)=>Array(Math.max(0,Math.min(99,Math.floor(Number(config.quantities?.[i])||0)))).fill(pom.price)):[];
    prices.sort((a,b)=>a-b);
    const gift=prices.length?giftIndex(config):-1;
    const subtotal=prices.reduce((a,b)=>a+b,0),saving=gift>=0?window.CuscoCatalog.poms[gift].price:0;
    const textEmbroidery=model&&hasText(config)?textPrice:0,motifEmbroidery=model&&hasMotif(config)?motifPrice:0;
    const embroidery=textEmbroidery+motifEmbroidery;
    return {base,count:prices.length,paidCount:prices.length-(gift>=0?1:0),giftPom:gift,giftName:gift>=0?window.CuscoCatalog.poms[gift].name:'',subtotal,saving,textEmbroidery,motifEmbroidery,embroidery,known:Number.isFinite(base),total:(base||0)+subtotal-saving+embroidery};
  }
  return {textPrice,motifPrice,hasText,hasMotif,hasEmbroidery,quote,describe,giftChoices,giftIndex,normalizeGift,chooseGift};
})();

})();
